module.exports = __webpack_public_path__ + "945b9e4c23a5c1d591f56ff744fe0260.svg";